import { GeneralFacilityType } from "../../assets/data/Constants";
import { TkSearchFormListItem } from "../../type/componentsType/TkSearchForm";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepperData = [
  "施設選択",
  "対象施設一覧/解除内容入力",
  "入力内容確認",
  "機構へ提出",
];

const headList = [
  { headTitle: "名称" },
  { headTitle: "施設区分" },
  { headTitle: "施設種類" },
  { headTitle: "ステータス" },
  { headTitle: "申請に関する状況" },
  { headTitle: "加入職員数" },
];

const facilityTypeList = Object.entries(GeneralFacilityType).map((label) => {
  return { value: label[0], label: label[0] };
});

const searchList: TkSearchFormListItem[] = [
  {
    keyword: "facilityType",
    type: "selectFrom",
    label: "施設種類",
    selectPropsList: facilityTypeList,
  },
  {
    keyword: "facilityName",
    type: "label",
    label: "施設名",
    inputProps: { maxLength: 24 },
  },
];

const schema = {
  facilityName: {
    maxLength: {
      value: 24,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "24"),
    },
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
  },
};

const noticeMessage =
  "　部分解除手続きにあたって、事前に従業状況を最新の状況に更新いただく必要があります。従業状況が最新になっていない場合には、最初に従業状況の更新をお願いします。\\n　従業状況の更新が完了している場合は「次へ」ボタンをクリックしてください。\\n　完了していない場合は「従業状況の更新」ボタンをクリックしてください。\\n　なお、当該手続きによる解除は退職手当金が支給されません。";

export { stepperData, headList, searchList, noticeMessage, schema };
